import React from 'react';
import {
  Form,
  Card,
  Space,
  message,
  Row,
  Col,
  Input,
  // Select,
  DatePicker
} from 'antd';
import FormItem from '@/common/FormItem';
import styles from '@/common/Layout/index.module.less';
import CustomButton from '@/common/CustomButton';
import Layout from '@/common/Layout';
import { history } from 'app/history';
import { useGetUacrOfSamplingOrDbarsQuery } from '../../redux/apiSlice';
import moment from 'moment';
import Spinner from '../../../../common/Spinner';
import { useParams } from 'react-router-dom';

const AdminPage = () => {
  const [form] = Form.useForm();
  const params = useParams();

  const [messageApi, contextHolder] = message.useMessage();
  const handleShowMessage = (messageType, messageText) => {
    messageApi.open({
      type: messageType,
      content: messageText
    });
  };

  const { data, isError, error, isLoading } = useGetUacrOfSamplingOrDbarsQuery({
    id: params.id
  });

  // Build activity logs array — support both new format and legacy flat fields
  const getActivityLogs = () => {
    if (!data?.data) return [];
    const record = data.data;
    const activityLogs = record.uacr_cleaning_activity_logs;

    if (activityLogs && activityLogs.length > 0) {
      return activityLogs;
    }

    // Legacy: construct single activity from parent flat fields
    return [
      {
        activity_start_time_user_id: record.activity_start_time_user_id,
        activity_start_time_date: record.activity_start_time_date,
        activity_end_time_user_id: record.activity_end_time_user_id,
        activity_end_time_date: record.activity_end_time_date,
        laf_on_time: record.laf_time,
        laf_off_time: record.laf_off_time,
        type_of_cleaning: record.type_of_cleaning,
        start_date: record.start_date,
        end_date: record.end_date,
        done_by: record.done_by,
        done_by_date: record.done_by_date,
        verified_by: record.verified_by,
        verified_by_date: record.verified_by_date,
        remarks: record.remarks,
        cleaning_log_book_accessories: record.cleaning_log_book_accessories
      }
    ];
  };

  let content;
  if (isLoading) {
    content = <Spinner />;
  } else if (data) {
    const record = data.data;
    const activityLogs = getActivityLogs();

    content = (
      <Space direction="vertical" style={{ width: '100%' }}>
        {contextHolder}
        <Layout sider={false}>
          {/* ========== HEADER CARD ========== */}
          <Card
            title="USAGE AND CLEANING RECORD OF SAMPLING / DISPENSING BOOTH AND ROOM"
            className={styles.CustomPanel}
          >
            <Form form={form} layout="vertical" disabled>
              <Row gutter={24}>
                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                  <FormItem
                    label="Area (Equipment ID)"
                    className={styles.customLable}
                  >
                    <Input
                      value={
                        record?.sampling_dispensing_booth_area_master
                          ?.description
                          ? `${record.sampling_dispensing_booth_area_master.description} (${record.sampling_dispensing_booth_area_master.area})`
                          : record?.sampling_dispensing_booth_area_master
                              ?.area || ''
                      }
                      style={{ width: '100%' }}
                    />
                  </FormItem>
                </Col>
                <Col xs={24} xl={12} span={24} md={24} sm={24}>
                  <FormItem
                    label="Product / Material Name"
                    className={styles.customLable}
                  >
                    <Input
                      value={record?.laf_product_name || ''}
                      style={{ width: '100%' }}
                    />
                  </FormItem>
                </Col>
                <Col xs={24} xl={12} span={24} md={24} sm={24}>
                  <FormItem
                    label="Product Batch No. / In-House Batch No."
                    className={styles.customLable}
                  >
                    <Input
                      value={record?.laf_product_batch_no || ''}
                      style={{ width: '100%' }}
                    />
                  </FormItem>
                </Col>
              </Row>
            </Form>
          </Card>

          <br />

          {/* ========== CLEANING ACTIVITY CARDS ========== */}
          {activityLogs.map((log, index) => {
            const activityStartDisplay = log.activity_start_time_date
              ? moment(log.activity_start_time_date).format(
                  'DD-MM-YYYY HH:mm:ss'
                )
              : '';
            const activityEndDisplay = log.activity_end_time_date
              ? moment(log.activity_end_time_date).format('DD-MM-YYYY HH:mm:ss')
              : '';

            const lafOnDisplay =
              log.laf_on_time === 'N/A'
                ? 'N/A'
                : log.laf_on_time
                ? moment(log.laf_on_time).isValid()
                  ? moment(log.laf_on_time).format('DD-MM-YYYY HH:mm:ss')
                  : log.laf_on_time
                : '';

            const lafOffDisplay =
              log.laf_off_time === 'N/A'
                ? 'N/A'
                : log.laf_off_time
                ? moment(log.laf_off_time).isValid()
                  ? moment(log.laf_off_time).format('DD-MM-YYYY HH:mm:ss')
                  : log.laf_off_time
                : '';

            const accessories = log.cleaning_log_book_accessories || [];

            return (
              <div key={log.id || index}>
                <Card
                  title={`Cleaning Activity Log ${index + 1}`}
                  className={styles.CustomPanel}
                >
                  <Form layout="vertical" disabled>
                    <Row gutter={24}>
                      <Col xs={24} xl={12} span={24} md={24} sm={24}>
                        <FormItem
                          label="LAF On Time"
                          className={styles.customLable}
                        >
                          <Input
                            value={lafOnDisplay}
                            style={{ width: '100%' }}
                          />
                        </FormItem>
                      </Col>
                      <Col xs={24} xl={12} span={24} md={24} sm={24}>
                        <FormItem
                          label="Activity Start Date & Time"
                          className={styles.customLable}
                        >
                          <Input
                            value={activityStartDisplay}
                            style={{ width: '100%' }}
                          />
                        </FormItem>
                      </Col>
                      <Col xs={24} xl={12} span={24} md={24} sm={24}>
                        <FormItem
                          label="Activity End Date & Time"
                          className={styles.customLable}
                        >
                          <Input
                            value={activityEndDisplay}
                            style={{ width: '100%' }}
                          />
                        </FormItem>
                      </Col>

                      <Col xs={24} xl={12} span={24} md={24} sm={24}>
                        <FormItem
                          label="LAF Off Time"
                          className={styles.customLable}
                        >
                          <Input
                            value={lafOffDisplay}
                            style={{ width: '100%' }}
                          />
                        </FormItem>
                      </Col>
                      <Col xs={24} xl={12} span={12} md={24} sm={24}>
                        <FormItem
                          label="Type of Cleaning"
                          className={styles.customLable}
                        >
                          <Input
                            value={log.type_of_cleaning || ''}
                            style={{ width: '100%' }}
                          />
                        </FormItem>
                      </Col>
                      <Col xs={24} xl={12} span={24} md={24} sm={24}>
                        <FormItem
                          label="Start Date & Time"
                          className={styles.customLable}
                        >
                          <DatePicker
                            showTime
                            value={
                              log.start_date ? moment(log.start_date) : null
                            }
                            style={{ width: '100%' }}
                          />
                        </FormItem>
                      </Col>
                      <Col xs={24} xl={12} span={24} md={24} sm={24}>
                        <FormItem
                          label="End Date & Time"
                          className={styles.customLable}
                        >
                          <DatePicker
                            showTime
                            value={log.end_date ? moment(log.end_date) : null}
                            style={{ width: '100%' }}
                          />
                        </FormItem>
                      </Col>
                      <Col xs={24} xl={12} span={24} md={24} sm={24}>
                        <FormItem
                          label="Cleaning Accessories"
                          className={styles.customLable}
                        >
                          <Input
                            value={accessories.length > 0 ? 'YES' : 'N/A'}
                            style={{ width: '100%' }}
                          />
                        </FormItem>
                      </Col>
                      <Col xs={24} xl={12} span={24} md={24} sm={24}>
                        <FormItem
                          label="Done By User Id & Date"
                          className={styles.customLable}
                        >
                          <Input
                            value={
                              log.done_by
                                ? `${log.done_by} (${moment(
                                    log.done_by_date
                                  ).format('DD-MM-YY')})`
                                : ''
                            }
                            style={{ width: '100%' }}
                          />
                        </FormItem>
                      </Col>
                      <Col xs={24} xl={12} span={24} md={24} sm={24}>
                        <FormItem
                          label="Verified By User Id & Date"
                          className={styles.customLable}
                        >
                          <Input
                            value={
                              log.verified_by
                                ? `${log.verified_by} (${moment(
                                    log.verified_by_date
                                  ).format('DD-MM-YY')})`
                                : ''
                            }
                            style={{ width: '100%' }}
                          />
                        </FormItem>
                      </Col>
                      <Col xs={24} xl={12} span={24} md={24} sm={24}>
                        <FormItem
                          label="Remarks"
                          className={styles.customLable}
                        >
                          <Input
                            value={log.remarks || ''}
                            style={{ width: '100%' }}
                          />
                        </FormItem>
                      </Col>
                    </Row>
                  </Form>
                </Card>
                <br />
              </div>
            );
          })}

          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <CustomButton
              className={styles.inwardButton}
              type="primary"
              ghost
              onClick={() => history.back()}
            >
              Back
            </CustomButton>
          </div>
        </Layout>
      </Space>
    );
  } else if (isError) {
    handleShowMessage('error', error?.data?.message);
    content = 'Something went wrong!';
  }

  return <>{content}</>;
};
export default AdminPage;
